import React, { useEffect, useRef, useState } from "react";
import { FaPlus } from "react-icons/fa6";
import ModalProps from "@ltypes/modalProps";
import UserService from "@services/UserService";
import Modal from "@components/modals/Modal/Modal";
import TextField from "@components/forms/TextField/TextField";
import { SearchItemType } from "@components/forms/SearchItem/SearchItem";
import './SearchItemModal.scss';
import toast from "react-hot-toast";

type SearchItemModalProps = {
    path: string,
    inputPlaceholder?: string,
    onSelect: (item: SearchItemType) => void,
} & ModalProps;

function SearchItemModal(props: SearchItemModalProps) {
    const [search, setSearch] = useState<string>('');
    const [items, setItems] = useState<Array<SearchItemType>>([]);

    const timerRef = useRef<any>(null);

    const apiService = new UserService;

    const handleClick = (item: SearchItemType) => {
        props.onSelect(item);
        props.onHide();
    };

    const handleSearch = (value: string) => {
        setSearch(value);

        clearTimeout(timerRef.current);

        if(value.trim() === '') {
            return;
        }

        timerRef.current = setTimeout(() => {
            apiService.call('GET', props.path + '?search=' + value).then((data: any) => {
                setItems(data.body);
            }).catch(e => {
                toast.error('Unable to get places');
            });
        }, 300);
    };

    useEffect(() => {
        setSearch('');
        setItems([]);
    }, [props.visible]);
    
    return (
        <Modal className="modal-searchitem" visible={props.visible} onHide={props.onHide}>
            <div className="row g-3">
                <div className="col-12">
                    <TextField value={search} onChange={handleSearch} placeholder={props.inputPlaceholder ?? 'Search'}/>
                </div>

                <div className="col-12">
                    <div className="list">
                        {items.map((item: SearchItemType, index: number) => (
                            <div key={index}className="item" onClick={() => handleClick(item)}>
                                <span className="item-label">{item.label}</span>
                                <span className="item-description">{item.description}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default SearchItemModal;
